module.exports = __webpack_public_path__ + "static/media/pdf.49d4041b.png";